<template>
    <v-container class="container" fluid>
        <v-toolbar dense dark color="secondary" v-if="onlyShow != true">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Site Readings</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <div
                v-if="readings == ''"
                class="text-center align-md-content-center"
            >
                <v-progress-circular
                    :size="30"
                    :width="5"
                    color="primary"
                    class=" my-5"
                    indeterminate
                ></v-progress-circular>
            </div>
            <v-row v-if="readings != ''" class="mx-5">
                <v-col cols="12">
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="text-center">
                                    Site #
                                </th>
                                <th class="text-center">
                                    Tank #
                                </th>
                                <th class="text-center">
                                    Product
                                </th>
                                <th class="text-center">
                                    Volume
                                </th>
                                <th class="text-center">
                                    SafeFill
                                </th>
                                <th class="text-center">
                                    Ullage
                                </th>
                                <th class="text-center">
                                    Reading Time
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in readings"
                                :key="item.TankNum"
                                :v-model="item.active"
                            >
                                <td class="text-center">
                                    {{ item.SiteNum }}
                                </td>
                                <td class="text-center">
                                    {{ item.TankNum }}
                                </td>
                                <td class="text-center">
                                    {{ item.Product }}
                                </td>
                                <td class="text-center">
                                    {{ item.Volume }}
                                </td>
                                <td class="text-center">
                                    {{ item.Safefill }}
                                </td>
                                <td class="text-center">
                                    {{ item.Ullage }}
                                </td>
                                <td class="text-center">
                                    {{ item.DateTime }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row v-show="readings != ''" class="mx-5">
                <v-col cols="12" class="p-5">
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="text-center">Product</th>
                                <th class="text-center">Volume</th>
                                <th class="text-center">Ullage</th>
                                <th class="text-center">Daily Average</th>
                                <th class="text-center">Stat AvgDaily</th>
                                <th class="text-center">RO Hrs</th>
                                <th v-if="onlyShow != true">Quantity</th>
                                <th v-if="onlyShow != true">RT Hrs</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, index) in products"
                                :key="item.Product"
                                :v-model="item.active"
                                class="text-center"
                            >
                                <td>
                                    {{ item.Product }}
                                </td>
                                <td>
                                    {{ item.Volume }}
                                </td>
                                <td>
                                    {{ item.Ullage }}
                                </td>
                                <td>
                                    {{ item.AvgDaily }}
                                </td>
                                <td>
                                    {{ item.StatAvgDaily }}
                                </td>
                                <td>
                                    {{ item.ROHrs }}
                                </td>
                                <td v-if="onlyShow != true">
                                    <v-text-field
                                        v-model="item.Quantity"
                                        type="number"
                                        hide-details
                                        dense
                                    ></v-text-field>
                                </td>
                                <td v-if="onlyShow != true">
                                    <v-text-field
                                        disabled
                                        v-model="RTHrs[index]"
                                        hide-details
                                        dense
                                    ></v-text-field>
                                </td>
                            </tr>
                            <tr v-if="onlyShow != true">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <v-text-field
                                        disabled
                                        dense
                                        hide-details
                                        v-model="orderTot"
                                    ></v-text-field>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'SiteReadings',
    props: ['onlyShow'],
    data: function() {
        return {
            readings: [],
            products: [],
            dataLoading: false,
            total: 0
        };
    },

    mounted() {
        this.loadSiteReadings(this.$store.state.siteReadings.SiteNum);
        this.loadProductTotals(this.$store.state.siteReadings.SiteNum);
    },
    watch: {
        '$store.state.siteReadings.SiteNum': function() {
            (this.readings = []),
                (this.products = []),
                this.loadSiteReadings(this.$store.state.siteReadings.SiteNum);
            this.loadProductTotals(this.$store.state.siteReadings.SiteNum);
        }
    },

    computed: {
        RTHrs() {
            return this.products.map((item, index) => {
                var SafefillQty =
                    parseInt(item.Quantity) -
                    parseInt(this.products[index].Ullage);
                if (SafefillQty < 0) {
                    return 0;
                }
                return Math.round(SafefillQty / (item.AvgDaily / 18));
            });
        },
        orderTot() {
            return this.products.reduce(getOrderTotal, 0);

            function getOrderTotal(total, item) {
                var q = parseInt(item.Quantity);
                if (isNaN(q)) {
                    return total + 0;
                } else {
                    return total + q;
                }
            }
        }
    },

    methods: {
        loadSiteReadings: function(stationID) {
            (this.readings = []), (this.dataLoading = true);
            this.$store.state.isLoading = true;
            console.log(stationID);
            if (stationID != '') {
                axios
                    .get('ftp-readings/reads/station/' + stationID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.readings = response.data;
                        this.dataLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            this.$store.state.isLoading = false;
            console.log(this.readings);
        },
        loadProductTotals: function(stationID) {
            this.dataLoading = true;
            (this.products = []), (this.$store.state.isLoading = true);
            console.log(stationID);
            if (stationID != '') {
                axios
                    .get('ftp-readings/reads/station/t/' + stationID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.products = response.data;
                        this.dataLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            this.$store.state.isLoading = false;
            console.log(this.readings);
        }
        // calculateRTHours: function(i) {
        //     console.log(this.products[i].Quantity);
        //     this.products[i].RTHrs =
        //         (this.products[i].Quantity + this.readings[i].Safefill) /
        //         this.products[i].AvgDaily /
        //         18;
        //     console.log(this.products[i].RTHrs);
        // }
    }
};
</script>
